export const toOnePasswordInputCreateRequest = ({
  apiToken,
  endPoint,
  onePasswordName,
  onePasswordStoreFullMessage,
  onePasswordThrottleEnabled,
  pollingInterval,
  contentTypes,
  overrideSource
}) => ({
  name: onePasswordName.value,
  polling_interval: pollingInterval.value,
  api_token: apiToken.value,
  store_full_message: onePasswordStoreFullMessage.value,
  enable_throttling: !!(onePasswordThrottleEnabled == null ? void 0 : onePasswordThrottleEnabled.value),
  end_point: endPoint.value,
  content_type: contentTypes.value.split(","),
  override_source: overrideSource.value
});
export const toGenericInputCreateRequest = ({
  apiToken,
  endPoint,
  onePasswordName,
  onePasswordStoreFullMessage,
  onePasswordThrottleEnabled,
  pollingInterval,
  contentTypes,
  overrideSource
}) => ({
  type: "org.graylog.enterprise.integrations.onepassword.OnePasswordInput",
  title: onePasswordName.value,
  global: false,
  configuration: {
    polling_interval: pollingInterval.value,
    api_token: apiToken.value,
    end_point: endPoint.value,
    throttling_allowed: !!(onePasswordThrottleEnabled == null ? void 0 : onePasswordThrottleEnabled.value),
    store_full_message: onePasswordStoreFullMessage.value,
    content_type: contentTypes.value.split(","),
    override_source: overrideSource.value
  }
});
